// extracted by mini-css-extract-plugin
export default {"badgeNew":"_3QgDT","upgrade":"_29ZQv"};